import { useEffect, useMemo } from 'react';

import { ReactComponent as SearchIcon } from "../../../../media/white_search_icon.svg";

import { validateFilterInvoice } from '../../../../utils/invoice/validateFilter';
import { ErrorsHFilterForm, HFilterForm } from '../../../../interfaces/historial.interface';
import { State } from '../../../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionsHistorialFiltro } from '../../../../actions/action-creators';
import { getTipoEstablecimiento, getTiposDocumento } from '../../../../actions/catalogos.actions';
import { DICCIONARIO } from '../../../../constants/Diccionario';
import SearchSelect from '../../../../components/Inputs/SearchSelect';
import { historialSetActivePage, historialSetTotalPages } from '../../../../actions/historial/historialFilter.actions';

export const FilterForm = () => {
  const {fecha_actual} = useSelector((state: State) => state.general); 
  const formFilter: HFilterForm = useSelector((state: State) => state.historial.formFilter);
  const errors: ErrorsHFilterForm = useSelector((state: State) => state.historial.errorsFilter);
  const { tipoDocumento, tipoEstablecimientos, tipoDocumentosEmision } = useSelector((state: State) => state.catalogos);

  const dispatch = useDispatch();

  const {
    historialFilterHandleChangeForm,
    historialFilterHandleErrors,
    historialFilterChangeForm,
    historialFilterErrorChange,
    historialSetFilterSearch,
    getTransactions,
  } = bindActionCreators(
    actionsHistorialFiltro,
    dispatch
  )

  useEffect(() => {
    if (tipoDocumento.length === 0) { dispatch(getTiposDocumento()); }
    if (tipoEstablecimientos.length === 0) { dispatch(getTipoEstablecimiento()); }

    if (!formFilter.fechaInicial && !formFilter.fechaFinal) {
      historialFilterChangeForm({fechaFinal: fecha_actual?.FechaInput, fechaInicial: fecha_actual?.FechaInput});
    }
  }, [])

    const docClienteActual = useMemo(() => {
      if (formFilter.tipoDocCliente !== "") {
        return tipoDocumento.find((tipo) => tipo.codigo === formFilter.tipoDocCliente)?.valor;
      } else {
        return DICCIONARIO.NUMERO_IDENTIFICACION
      }
    }, [formFilter.tipoDocCliente])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
    historialFilterHandleChangeForm(e)

  const handleErrors = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
    historialFilterHandleErrors(e, formFilter, errors, tipoDocumento);

  const handleFilterSearch = (e: any) => {
    e.preventDefault();

    const errSubmit = validateFilterInvoice(formFilter, tipoDocumento)
    if (Object.keys(errSubmit).length > 0) {
      dispatch(historialFilterErrorChange({
        nit: errSubmit?.nit || "",
        fechaFinal: errSubmit?.fechaFinal || "",
        fechaInicial: errSubmit?.fechaInicial || "",
        tipoDTE: errSubmit?.tipoDTE || "",
        documento: errSubmit?.documento || "",
        tipoDocCliente: errSubmit?.tipoDocCliente || "",
        nrcEmisor: errSubmit?.nrcEmisor || "",
        nrcReceptor: errSubmit?.nrcReceptor || "",
        nombreReceptor: errSubmit?.nombreReceptor || "",
        referencia: errSubmit?.referencia || "",
      }))
    } else {
      dispatch(historialFilterErrorChange({ nit: '', fechaFinal: '', fechaInicial: '', tipoDTE: '', documento: '', tipoDocCliente: '', nrcEmisor: '', nrcReceptor: '', nombreReceptor: '', referencia: '' }))
    }

    for (let [key, value] of Object.entries(errSubmit)) {
      if (value || value !== "") return;
    }

    historialSetActivePage(0);
    historialSetTotalPages(0);
    historialSetFilterSearch(formFilter);
    getTransactions(formFilter);
  }

  return (
    <form onSubmit={handleFilterSearch}>
      <div className='history-content-filter'>
        <div className='history-section-filter'>
          <div className='filter-field' id='filterInitDate'>
            <label htmlFor='DateInit' className='field-label m'>
              Fecha inicial
            </label>
            <input autoComplete='off'
              type='date'
              className='m text-field normal w-input'
              maxLength={256}
              name='fechaInicial'
              data-name='DateInit'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.fechaInicial}
              max={fecha_actual?.FechaInput}
              style={{ minWidth: '185px' }}
            />
            {errors.fechaInicial && <p className='alert s'>{errors.fechaInicial}</p>}
          </div>
          <div className='filter-field'>
            <label htmlFor='DateEnd' className='field-label m'>
              Fecha final
            </label>
            <input autoComplete='off'
              type='date'
              className='m text-field normal w-input'
              maxLength={256}
              name='fechaFinal'
              data-name='DateEnd'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.fechaFinal}
              max={fecha_actual?.FechaInput}
              style={{ minWidth: '185px' }}
            />
            {errors.fechaFinal && <p className='alert s'>{errors.fechaFinal}</p>}
          </div>
        </div>

        <div className='history-section-filter'>
          <div className='filter-field' style={{minWidth: '250px', maxWidth: '250px'}}>
            <label htmlFor='TypeInvoice' className='field-label m'>
              {DICCIONARIO.TIPO_DTE}
            </label>
            <SearchSelect
              defaultValue={null}
              placeholder='Tipo de documento' 
              data={[{nombre: "Mostrar todos los documentos", codigodocumento: '-1'}, ...tipoDocumentosEmision]} 
              value={formFilter.tipoDTE} 
              name='tipoDTE' 
              keyNameText='nombre' 
              keyNameValue='codigodocumento' 
              disabled={false} 
              onChange={(value: any) => {handleInputChange({target: {value: value?.value, name: 'tipoDTE'}}) ; handleErrors({target: {value: value?.value, name: 'tipoDTE'}})}}
            />
            {errors.tipoDTE && <p className='alert s'>{errors.tipoDTE}</p>}
          </div>
        </div>
        <div className='history-section-filter'>
          <div className='filter-field'>
            <label htmlFor='NIT' className='field-label m'>
              NIT emisor
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              autoFocus={true}
              maxLength={16}
              data-name='NIT'
              name='nit'
              placeholder='NIT'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.nit}
            />
            {errors.nit && <p className='alert s'>{errors.nit}</p>}
          </div>
          <div className='filter-field'>
            <label htmlFor='nrcEmisor' className='field-label m'>
              NRC emisor
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              autoFocus={true}
              data-name='nrcEmisor'
              name='nrcEmisor'
              placeholder='NRC emisor'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.nrcEmisor}
            />
            {errors.nrcEmisor && <p className='alert s'>{errors.nrcEmisor}</p>}
          </div>
        </div>
        <div className='history-section-filter'>
          <div className='filter-field' style={{minWidth: '220px', maxWidth: '220px'}}>
            <label htmlFor='nombreReceptor' className='field-label m'>
              Nombre receptor
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              autoFocus={true}
              maxLength={45}
              data-name='nombreReceptor'
              name='nombreReceptor'
              placeholder={"Nombre del receptor"}
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.nombreReceptor}
            />
          </div>
          <div className='filter-field' style={{minWidth: '220px', maxWidth: '220px'}}>
            <label htmlFor='tipoDocCliente' className='field-label m'>
              Tipo de identificación
            </label>
            <SearchSelect 
            defaultValue={null}
              placeholder='Tipo de identificación' 
              data={[{valor: "Selecciona una opción", codigo: ''}, ...tipoDocumento] } 
              value={formFilter.tipoDocCliente} 
              name='tipoDocCliente' 
              keyNameText='valor' 
              keyNameValue='codigo' 
              disabled={false} 
              onChange={(value: any) => {handleInputChange({target: {value: value?.value, name: 'tipoDocCliente'}}); handleErrors({target: {value: value?.value, name: 'tipoDocCliente'}})}}
            />
            {errors.tipoDocCliente && <p className='alert s'>{errors.tipoDocCliente}</p>}
          </div>
          <div className='filter-field'>
            <label htmlFor='documento' className='field-label m'>
              {docClienteActual}
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              autoFocus={true}
              maxLength={45}
              data-name='documento'
              name='documento'
              placeholder={docClienteActual}
              disabled={formFilter.tipoDocCliente === ""}
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.documento}
            />
            {errors.documento && <p className='alert s'>{errors.documento}</p>}
          </div>
          <div className='filter-field'>
            <label htmlFor='nrcReceptor' className='field-label m'>
              NRC
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              autoFocus={true}
              data-name='nrcReceptor'
              name='nrcReceptor'
              placeholder='NRC'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.nrcReceptor}
            />
            {errors.nrcReceptor && <p className='alert s'>{errors.nrcReceptor}</p>}
          </div>
          <div className='filter-field'>
            <label htmlFor='referencia' className='field-label m'>
              Referencia
            </label>
            <input autoComplete='off'
              type='text'
              className='m text-field normal w-input'
              maxLength={50}
              data-name='referencia'
              name='referencia'
              placeholder='Referencia'
              onChange={handleInputChange}
              onBlur={handleErrors}
              value={formFilter.referencia}
            />
            {errors.referencia && <p className='alert s'>{errors.referencia}</p>}
          </div>
        </div>
        <div>
          <button type='submit' className='icon-button filter-search-btn'>
            <SearchIcon width={20} height={20} />
          </button>
        </div>
      </div>
    </form>
  )
}
